import { insuranceImportService } from "./service";
import { InsuranceImport } from "./types";

export const submitInsuranceImport = async (insuranceImportId: string) => {
  const { data } = await insuranceImportService.post<InsuranceImport>(
    `/${insuranceImportId}/submit`
  );

  return data;
};
